import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({
  baseURL: API,
  timeout: 20000,
  // Serialize arrays as repeat-keys (facility=spa&facility=pool) so FastAPI's
  // List[str] query params parse correctly. Default axios uses facility[]=... which FastAPI ignores.
  paramsSerializer: { indexes: null },
});

// Attach JWT from localStorage to admin requests
http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("parkscanner_token");
  if (token && cfg.url && (cfg.url.startsWith("/admin") || cfg.url.startsWith("/auth/me"))) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export const api = {
  stats: () => http.get("/stats").then((r) => r.data),
  regions: () => http.get("/regions").then((r) => r.data),
  operators: () => http.get("/operators").then((r) => r.data),
  facilities: () => http.get("/facilities").then((r) => r.data),
  searchParks: (params) => http.get("/parks/search", { params }).then((r) => r.data),
  getPark: (slug, params) => http.get(`/parks/${slug}`, { params }).then((r) => r.data),
  comparePark: (ids, params) => http.get(`/parks/compare/${ids.join(",")}`, { params }).then((r) => r.data),
  deals: (params) => http.get("/deals", { params }).then((r) => r.data),
  regionGuide: (slug) => http.get(`/regions/${slug}`).then((r) => r.data),
  emailAlert: (payload) => http.post("/email-alerts", payload).then((r) => r.data),

  // Auth + admin
  login: (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  adminDashboard: () => http.get("/admin/dashboard").then((r) => r.data),
  adminToggleFeatured: (slug, featured) => http.post("/admin/featured", { slug, featured }).then((r) => r.data),
  adminEmailAlerts: () => http.get("/admin/email-alerts").then((r) => r.data),
  adminVisits: () => http.get("/admin/visits").then((r) => r.data),
  adminPurgeTestData: () => http.post("/admin/purge-test-data").then((r) => r.data),

  // Visit tracking (fire-and-forget)
  logVisit: (payload) => http.post("/visits", payload).then((r) => r.data),
};

export const FACILITY_LABELS = {
  pool: "Swimming Pool",
  entertainment: "Live Entertainment",
  dog_friendly: "Dog Friendly",
  beach: "Beach Access",
  wifi: "Free WiFi",
  kids_club: "Kids Club",
  restaurant: "Restaurant",
  bar: "Bar",
  spa: "Spa",
  surfing: "Surfing",
  watersports: "Watersports",
  golf: "Golf",
  fishing: "Fishing",
  horse_riding: "Horse Riding",
  adults_only: "Adults Only",
};

export const formatGBP = (n) => `£${Math.round(n).toLocaleString("en-GB")}`;
